import React, { useState } from "react";
import { CheckSquare, Pause, Play } from "react-feather";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Button } from "reactstrap";
import { HeaderSection } from "../../components/shared/HeaderSection";
import { GalleryImages } from "../../components/tourism/GalleryImages";

import { MapTourist } from "../../components/tourism/MapTourist";
import { MapPin, Phone } from "react-feather";

import ReactHtmlParser from "react-html-parser";

import ROUTES from "../../routes/routes";
import { getTouristAtractivesById } from "../../services/tourismService";
import { SubTitle } from "../../components/shared/SubTitle";

import nube from "../../assets/img/tourism/nube.png";
import temperature from "../../assets/img/tourism/baja-temperatura.png";
import montanas from "../../assets/img/tourism/montanas.png";

import ReactPlayer from "react-player";

const AtractiveDetail = () => {
  const [playing, setPlaying] = useState(true);

  const { id } = useParams();

  const { data, isError, isLoading, isFetching } = useQuery(
    ["atractive", id],
    () => getTouristAtractivesById(id)
  );

  if (isLoading) return <p>Cargando</p>;
  if (isFetching) return <p>Loading feaching...</p>;
  if (isError) return <p>error</p>;

  return (
    <>
      <section
        id="intro-detail"
        style={{
          backgroundImage: `url(${data.image})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <HeaderSection
          route={ROUTES.ATRACTIVES}
          resume="Volver a Atractivos Turisticos"
        />
        <div className="box-title">
          <h1>{data.name}</h1>
          <small>
            {data.subtype.category} - {data.subtype.type}
          </small>
        </div>
      </section>
      <Container>
        <Row
          className="cuadro-verde"
          style={{ marginTop: "35px", marginBottom: "25px" }}
        >
          <Col md="4" className="text-center">
            <img src={nube} height="70px" alt="Icon wearth" />
            <br />
            <br />
            <b>Clima: </b>
            {data.weather.toLowerCase()}
          </Col>

          <Col md="4" className="text-center">
            <img src={temperature} height="70px" alt="Icon wearth" />
            <br />
            <br />
            <b>Temperatura: </b>
            {data.temperature}
          </Col>
          <Col md="4" className="text-center">
            <img src={montanas} height="70px" alt="Icon wearth" />
            <br />
            <br />
            <b>Altitud: </b>
            {data.altitude}
          </Col>
        </Row>
        <hr />

        {ReactHtmlParser(data.content)}
        {data.link_platform && data.get_platform_display === "Youtube" ? (
          <>
            <div id="cont-video">
              <div className="video-hidden-publicity" />
              <ReactPlayer
                url={data.link_platform}
                playing={playing}
                style={{ margin: "1% auto" }}
              />
            </div>
            <div id="cont-btn-video">
              {playing ? (
                <Button color="info" onClick={() => setPlaying(false)}>
                  <Pause size={15} />
                </Button>
              ) : (
                <Button color="info" onClick={() => setPlaying(true)}>
                  <Play size={15} />
                </Button>
              )}
            </div>
          </>
        ) : null}

        <SubTitle title="Galería de Fotos" position="text-center"></SubTitle>
        <GalleryImages images={data.gallery_base_tourist} />
        <hr />

        <Row>
          <Col md="12">
            <SubTitle title="Ubicación" position="text-center"></SubTitle>
            <section className="cont-address">
              <div id="box-description-address">
                <p className="text-capitalize">
                  <MapPin size={14} />
                  {data.main_street}, {data.parish.nombre}
                </p>
                <hr />
                <p>
                  <Phone size={14} /> +593 {data.phone}
                </p>
              </div>
              <MapTourist
                lat={data.latitude}
                lng={data.longitude}
                zoom={18}
                width={"100%"}
                height={500}
              />
              <div className="map-hidden-publicity" />
            </section>
          </Col>
        </Row>

        {data.attractive_facilities.length > 0 ? (
          <>
            <Row>
              <SubTitle title="Facilidades" position="text-center"></SubTitle>

              <Row>
                {data.attractive_facilities.map(
                  (attractive_facilities, index) => (
                    <Col md="6" key={index}>
                      <p>
                        <CheckSquare size="14" style={{ marginRight: "5px" }} />
                        {attractive_facilities.facilities_name}
                      </p>
                    </Col>
                  )
                )}
                <hr />
                <br />
              </Row>
            </Row>
          </>
        ) : null}

        {data.services.length > 0 ? (
          <>
            <SubTitle title="Servicios" position="text-center"></SubTitle>
            <Row>
              {data.services.map((service, index) => (
                <Col md="6" key={index}>
                  <p>
                    <CheckSquare
                      size="14"
                      color="green"
                      style={{ marginRight: "5px" }}
                    />
                    {service.name}
                  </p>
                </Col>
              ))}
            </Row>
            <hr />
          </>
        ) : null}

        {data.activities.length > 0 ? (
          <>
            <SubTitle title="Actividades" position="text-center"></SubTitle>
            <Row>
              {data.activities.map((activitie, index) => (
                <Col md="6" key={index}>
                  <p>
                    <CheckSquare
                      size="14"
                      color="green"
                      style={{ marginRight: "5px" }}
                    />
                    {activitie.name}
                  </p>
                </Col>
              ))}
            </Row>
            <hr />
          </>
        ) : null}

        <section
          className="cont-info"
          style={{ padding: "25px 50px 25px 50px" }}
        >
          {data.attractive_income.length > 0 ? (
            <>
              <SubTitle
                title="Información Adicional"
                position="text-center"
              ></SubTitle>

              {data.attractive_income.map((attractive_income, index) => (
                <Col md="12" key={index}>
                  <Row>
                    <Col md="6">
                      <b>Ingreso : </b> {attractive_income.income_name}{" "}
                    </Col>
                    <Col md="6">
                      <b>Atención Todos los días :</b>{" "}
                      {attractive_income.attention_every_day === true
                        ? "SI"
                        : "NO"}
                    </Col>
                    <hr />
                    <Col md="6">
                      <b>Horario de Ingreso :</b>{" "}
                      {attractive_income.admission_schedule}
                    </Col>

                    <Col md="6">
                      <b>Ingreso de Salidad :</b>{" "}
                      {attractive_income.departure_schedule}
                    </Col>

                    <hr />
                    <Col md="6">
                      <b>Atención Fines de Semana y Vacaciones :</b>{" "}
                      {attractive_income.attention_weekends_holidays === true
                        ? "SI"
                        : "NO"}
                    </Col>
                  </Row>
                </Col>
              ))}
            </>
          ) : null}
        </section>
      </Container>
      <HeaderSection
        route={ROUTES.ATRACTIVES}
        resume="Volver a Atractivos Turisticos"
      />
    </>
  );
};

export default AtractiveDetail;
